// extracted by mini-css-extract-plugin
export default {"show-more-button":"_17szN","showMoreButton":"_17szN","show-more-button-large":"_1MVLF","showMoreButtonLarge":"_1MVLF"};